var hornstrup = hornstrup || {};
hornstrup.list4List3 = hornstrup.list4List3 || function () {
    //share links must have these id's: share-facebook share-twitter share-linkedin
    var self = this;


    this.init = function (callback) {

        $('.list4--version3+.list4--version3').last().addClass('list4--last');
        $('.list4--version3+.list4--version3').each(function(){
            $(this).addClass('list4--version3-after-each-other');
            $(this).prev().addClass('list4--version3-after-each-other');
        })



    }

    // public functions:
    return {
        init: init
    };
}();

